import React from 'react';

export const FLEET_PRIVACY_URL = 'https://fleet.logistixnerd.com/privacy.html';
export const FLEET_SUPPORT_URL = 'https://fleet.logistixnerd.com/support.html';

export default function AccountPrivacyActions() {
  return (
    <section aria-label="Privacy and support">
      <p><a href={FLEET_PRIVACY_URL} target="_blank" rel="noreferrer">Privacy policy</a>
        {' | '}<a href={FLEET_SUPPORT_URL} target="_blank" rel="noreferrer">Support</a></p>
    </section>
  );
}
